var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar_chart section mx-auto px-0 mt-5"},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("จำนวนรายการพืช")]),_c('canvas',{ref:"bar",attrs:{"id":"bar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }